import React from "react";
import ReactStars from "react-rating-stars-component";

const RatingStars = ({ star }) => {
  return (
    <div>
      <ReactStars
        count={5}
        edit={false}
        size={24}
        value={star}
        isHalf={true}
        emptyIcon={<i className="far fa-star"></i>}
        halfIcon={<i className="fa fa-star-half-alt"></i>}
        fullIcon={<i className="fa fa-star"></i>}
        activeColor="#ca8a04"
      />
    </div>
  );
};

export default RatingStars;
